<template>
  <Catalogs
    title="Вакансии"
    create-text="Новая"
    :fetch-data="fetchData"
    :route-create="'VacancyAdd'"
    :route-edit="'VacancyEdit'"
    :route-view="'VacancyView'"
    :route-path="'/vacancies'"
    :can-edit="canEditVacancyCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "Vacancies",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getVacancies(data);
    },
    canEditVacancyCatalogs() {
      return this.hasPermission([PERM.CATALOG_VACANCY_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/Vacancies.vue